const isRecognitionPaymentsSection = (
  s: PerformanceBoardTypes.SlideOut.SlideOutSection,
): s is PerformanceBoardTypes.SlideOut.RecognitionPaymentsSection => {
  return s.sectionType === 'Additional Payments';
};

export default isRecognitionPaymentsSection;
